function pad2(n) {
  return String(n).padStart(2, '0');
}

function toUTCStamp(date = new Date()) {
  return (
    date.getUTCFullYear().toString() +
    pad2(date.getUTCMonth() + 1) +
    pad2(date.getUTCDate()) +
    'T' +
    pad2(date.getUTCHours()) +
    pad2(date.getUTCMinutes()) +
    pad2(date.getUTCSeconds()) +
    'Z'
  );
}

function toDateOnly(yyyyMMddLike) {
  const [y, m, d] = String(yyyyMMddLike).split('-');
  return `${y}${m}${d}`;
}

function toLocalDateTime(dateStr, timeStr = '00:00') {
  const [y, m, d] = String(dateStr).split('-');
  const [hh, mm] = String(timeStr).split(':');
  return `${y}${m}${d}T${pad2(hh || 0)}${pad2(mm || 0)}00`;
}

function addOneDay(yyyyMMddLike) {
  const [y, m, d] = String(yyyyMMddLike).split('-').map(Number);
  const dt = new Date(y, (m || 1) - 1, d || 1);
  dt.setDate(dt.getDate() + 1);
  return (
    dt.getFullYear().toString() +
    pad2(dt.getMonth() + 1) +
    pad2(dt.getDate())
  );
}

function escapeICS(text = '') {
  return String(text)
    .replace(/\\/g, '\\\\')
    .replace(/\n/g, '\\n')
    .replace(/,/g, '\\,')
    .replace(/;/g, '\\;');
}

function buildEventLines(schedule, nowStamp) {
  const uidBase = schedule.id || `${schedule.title || 'evento'}-${schedule.date || Date.now()}`;
  const uid = `${uidBase}@igrejambv.com.br`;
  const summary = escapeICS(schedule.title || 'Escala');
  const description = escapeICS(schedule.observations || '');
  const location = escapeICS(schedule.location || '');

  const lines = [
    'BEGIN:VEVENT',
    `UID:${uid}`,
    `DTSTAMP:${nowStamp}`,
    `SUMMARY:${summary}`
  ];

  if (schedule.start_time) {
    lines.push(`DTSTART:${toLocalDateTime(schedule.date, schedule.start_time)}`);
    if (schedule.end_time) {
      lines.push(`DTEND:${toLocalDateTime(schedule.date, schedule.end_time)}`);
    }
  } else if (schedule.date) {
    lines.push(`DTSTART;VALUE=DATE:${toDateOnly(schedule.date)}`);
    lines.push(`DTEND;VALUE=DATE:${addOneDay(schedule.date)}`);
  }

  if (location) lines.push(`LOCATION:${location}`);
  if (description) lines.push(`DESCRIPTION:${description}`);
  lines.push(
    'BEGIN:VALARM',
    'ACTION:DISPLAY',
    'DESCRIPTION:Lembrete da escala (1 dia antes)',
    'TRIGGER:-P1D',
    'END:VALARM'
  );
  lines.push(
    'BEGIN:VALARM',
    'ACTION:DISPLAY',
    'DESCRIPTION:Lembrete da escala (12 horas antes)',
    'TRIGGER:-PT12H',
    'END:VALARM'
  );

  lines.push('END:VEVENT');
  return lines;
}

function buildNativeCalendarEvent(schedule = {}) {
  const baseDate = String(schedule?.date || '').slice(0, 10);
  if (!baseDate) return null;

  const startTime = schedule?.start_time || '09:00';
  const endTime = schedule?.end_time || (schedule?.start_time ? null : '10:00');
  const hasSpecificTime = Boolean(schedule?.start_time);
  const startDate = hasSpecificTime ? `${baseDate}T${startTime}:00` : `${baseDate}T09:00:00`;
  const endDate = hasSpecificTime
    ? `${baseDate}T${endTime || startTime}:00`
    : `${baseDate}T10:00:00`;

  return {
    title: schedule?.title || 'Escala',
    startDate: new Date(startDate).toISOString(),
    endDate: new Date(endDate).toISOString(),
    allDay: !hasSpecificTime,
    location: schedule?.location || '',
    notes: schedule?.observations || '',
  };
}

export function buildICSFromSchedules(schedules = []) {
  const safeSchedules = Array.isArray(schedules) ? schedules : [];
  const nowStamp = toUTCStamp();

  const header = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'PRODID:-//MBV App//Escalas//PT-BR'
  ];

  const events = safeSchedules.flatMap((schedule) => buildEventLines(schedule, nowStamp));
  const footer = ['END:VCALENDAR'];

  return [...header, ...events, ...footer].join('\r\n');
}

export function buildICSFromSchedule(schedule) {
  return buildICSFromSchedules([schedule]);
}

export function buildNativeCalendarEventsFromSchedules(schedules = []) {
  return (Array.isArray(schedules) ? schedules : []).map(buildNativeCalendarEvent).filter(Boolean);
}

export function buildNativeCalendarEventFromSchedule(schedule) {
  return buildNativeCalendarEvent(schedule);
}
